import { Badge } from '@shared/ui/badge';

import { EXIT_BADGE_LABEL } from '../config/investment.text';
import { INVEST_STATUS_BADGE_TONE, STATUS_BADGE_CLASS } from '../config/investment-badge.constant';
import type { ExitBadgeType } from '../model/exit';

export interface ExitBadgeProps {
  type: ExitBadgeType;
}

/** 회수 유형 배지. 값 → tone · 글자는 InvestStatusBadge 와 같은 표를 쓴다 */
export function ExitBadge({ type }: ExitBadgeProps) {
  return (
    <Badge
      tone={INVEST_STATUS_BADGE_TONE[type]}
      appearance="solid"
      size="sm"
      data-type={type}
      className={STATUS_BADGE_CLASS[type]}
    >
      {EXIT_BADGE_LABEL[type]}
    </Badge>
  );
}
